<script>
  import { afterUpdate } from "svelte";
  import { fade } from "svelte/transition";
  import dayjs from "dayjs";

  export let currency;
  export let text;

  function selectBannerTextByCurrency(textObj, currency) {
    if (!textObj || !textObj.usd) {
      return "";
    }

    const defaultText = textObj.usd;

    if (!currency) {
      return defaultText;
    }

    let cur = currency.toLowerCase();

    if (!textObj[cur]) {
      return defaultText;
    }

    return textObj[cur];
  }

  function leadZero(num) {
    if (num < 10) {
      return `0${num}`;
    }

    return num;
  }

  function formatDiff(diff) {
    const { hours, minutes, seconds } = diff;
    return `${leadZero(hours)}h:${leadZero(minutes)}m:${leadZero(seconds)}s`;
  }

  function getDiff(targetDate) {
    const seconds = dayjs().diff(targetDate, "seconds");

    let totalSeconds = -1 * seconds;
    const hours = Math.floor(totalSeconds / (60 * 60));
    totalSeconds -= hours * 60 * 60;
    const minutes = Math.floor(totalSeconds / 60);
    totalSeconds -= minutes * 60;

    return {
      hours,
      minutes,
      seconds: totalSeconds,
    };
  }

  let updateIntervalRef = null;

  function getText() {
    if (updateIntervalRef) {
      clearInterval(updateIntervalRef);
    }

    let bannerText = selectBannerTextByCurrency(text, currency);

    if (!bannerText) {
      return;
    }

    const timeRegex = /#time\((?<date>.+)\)/m;
    const match = bannerText.match(timeRegex);

    if (match) {
      const targetDate = match.groups.date;
      const isBeforeTargetDate = dayjs().isBefore(dayjs(targetDate));

      bannerText = isBeforeTargetDate
        ? bannerText.replace(match[0], formatDiff(getDiff(targetDate)))
        : bannerText.replace(match[0], "00:00:00");

      updateIntervalRef = setInterval(() => {
        textToDisplay = getText();
      }, 1000);
    }

    return {
      text: bannerText,
      isCountdownTimer: match,
    };
  }

  let textToDisplay = getText();

  afterUpdate(() => {
    textToDisplay = getText();
  });
</script>

{#if !textToDisplay.isCountdownTimer}
  {#each [textToDisplay] as textToDisplay (textToDisplay)}
    <span in:fade={{ duration: 1000 }} class="hide-line-breaks-on-desktop"
      >{@html textToDisplay.text || ""}</span
    >
  {/each}
{:else}
  <span class="hide-line-breaks-on-desktop"
    >{@html textToDisplay.text || ""}</span
  >
{/if}

<style>
  @media (min-width: 480px) {
    :global(.hide-line-breaks-on-desktop br) {
      content: " ";
    }

    :global(.hide-line-breaks-on-desktop br:after) {
      content: " ";
    }
  }
</style>
